export default __webpack_public_path__ + "static/media/logo.59e454f2.svg";